module.exports = __webpack_public_path__ + "img/designguide@2x.4671e56.webp";